import { render, staticRenderFns } from "./product.vue?vue&type=template&id=61da7f6e&scoped=true&"
import script from "./product.vue?vue&type=script&lang=js&"
export * from "./product.vue?vue&type=script&lang=js&"
import style0 from "./product.vue?vue&type=style&index=0&id=61da7f6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61da7f6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61da7f6e')) {
      api.createRecord('61da7f6e', component.options)
    } else {
      api.reload('61da7f6e', component.options)
    }
    module.hot.accept("./product.vue?vue&type=template&id=61da7f6e&scoped=true&", function () {
      api.rerender('61da7f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/product_price_maintain/components/product.vue"
export default component.exports